var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('button',{on:{"click":_vm.btn}},[_vm._v("点击")]),_c('div',{staticClass:"frame-container"},[_c('div',{class:['frame-content-' + _vm.space],domProps:{"innerHTML":_vm._s(_vm.content_html)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }